import {getHeadingTitle, getBreadcrump, tranformItem} from 'cms/helpers/common';
import {getCategories} from 'cms/faqs/common';

const categoryStore = (cms, translations) => {
  const {id, h1, breadcrump, title, content, children, sidebar} = cms;

  return {
    title: getHeadingTitle(h1, title),
    content: content.rendered,
    breadcrump: getBreadcrump(breadcrump),
    categories: getCategories(sidebar, id),
    articles: tranformItem(['ID', 'post_title', 'post_content', 'permanlink'])(children),
    translations
  };
};

export default categoryStore;
